import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetCall, apiPostCall, apiPutCall } from '../utility/site-apis'

const initialState = {
  isFetching: false,
  error: null,
  errorPromo: null,
  allTrivias: [],
  singleTrivias: {},
  questions: null,
  triviaInfo: {},
  verifyPromo: null,
  razorpayorderID: null,
  contestantId: null,
  verifyOrderSucces: false,
  upcomingContest: [],
  ongoingContest: [],
  mainContestListing: [],
  contests: {},
  offerList: [],
}

export const listAllTrivias = createAsyncThunk(
  'trivia/listAllTrivias',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/trivia/list`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const detailAllTrivias = createAsyncThunk(
  'trivia/detailAllTrivias',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/trivia/${params.id}`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const validatePromo = createAsyncThunk(
  'trivia/validatePromo',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/promo/validate`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const createOrder = createAsyncThunk(
  'trivia/createOrder',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/order/new`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const verifyOrder = createAsyncThunk(
  'trivia/verifyOrder',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/order/verify`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const triviaQuestionsById = createAsyncThunk(
  'trivia/triviaQuestionsById',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/contestants/${params.contestantId}`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateContestant = createAsyncThunk(
  'trivia/updateContestant',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/contestants/${params.contestantId}/answer`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const upcomingContestSlider = createAsyncThunk(
  'contestSlider/upcomingContestSlider',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/contestSlider/upcomingContestSlider`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const ongoingContestSlider = createAsyncThunk(
  'contestSlider/ongoingContestSlider',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/contestSlider/ongoingContestSlider`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const mainContestListingSlider = createAsyncThunk(
  'contestSlider/mainContestListingSlider',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/contestSlider/mainContestListingSlider`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const ContestList = createAsyncThunk(
  'contestSlider/ContestList',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/trivia/list`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data.data
  }
)

export const listAllPromos = createAsyncThunk(
  'trivia/listAllPromos',
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/promo/fetch`, params)
   if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data ? response.data.data : []
  }
)

export const counterSlice = createSlice({
  name: 'trivia',
  initialState,
  reducers: {
    clearPromo: (state, action) => {
      state.verifyPromo = null
      state.errorPromo = null
    },
    setTriviaInfo: (state, action) => {
      state.triviaInfo = action.payload
    },
    clearPaymentInfo: (state, action) => {
      state.razorpayorderID = null
      state.verifyPromo = null
      state.verifyOrderSucces = false
    },
    clearTrivia: (state, action) => {
      state.questions = null
      state.contestantId = null
    },
  },
  extraReducers: {
    [listAllTrivias.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
    },
    [listAllTrivias.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [listAllTrivias.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.allTrivias = action.payload.data.data
    },
    // detailAllTrivias
    [detailAllTrivias.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
    },
    [detailAllTrivias.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [detailAllTrivias.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.singleTrivias = action.payload.data
    },

    // validatePromo
    [validatePromo.pending]: (state, action) => {
      state.isFetching = true
      state.errorPromo = null
      state.verifyPromo = null
    },
    [validatePromo.rejected]: (state, action) => {
      state.isFetching = false
      state.errorPromo = action?.payload?.message
    },
    [validatePromo.fulfilled]: (state, action) => {
      state.isFetching = false
      state.errorPromo = null
      state.verifyPromo = action.payload.data
    },
    // createOrder
    [createOrder.pending]: (state, action) => {
      state.isFetching = true
      state.errorPromo = null
      state.razorpayorderID = null
    },
    [createOrder.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [createOrder.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.razorpayorderID = action.payload.data.razorpayorderID
    },
    // verifyOrder
    [verifyOrder.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.contestantId = null
      state.verifyOrderSucces = false
    },
    [verifyOrder.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [verifyOrder.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.contestantId = action.payload.data.contestant
      state.verifyOrderSucces = true
    },
    // triviaQuestionsById
    [triviaQuestionsById.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
    },
    [triviaQuestionsById.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [triviaQuestionsById.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.questions = action.payload.data
    },
    // updateContestant
    [updateContestant.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
    },
    [updateContestant.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [updateContestant.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.questions = action.payload.data
    },
    // upcomingContestSlider
    [upcomingContestSlider.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.upcomingContest = []
    },
    [upcomingContestSlider.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [upcomingContestSlider.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.upcomingContest = action.payload.data[0] ? action.payload.data[0].slides : []
    },
    // ongoingContestSlider
    [ongoingContestSlider.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.ongoingContest = []
    },
    [ongoingContestSlider.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [ongoingContestSlider.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.ongoingContest = action.payload.data[0] ? action.payload.data[0].slides : []

    },
    // mainContestListingSlider
    [mainContestListingSlider.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.mainContestListing = []
    },
    [mainContestListingSlider.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [mainContestListingSlider.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.mainContestListing = action.payload.data[0] ? action.payload.data[0].slides : []

    },
    // ContestList
    [ContestList.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      if (action?.meta?.arg?.pageNo == 1) {
        state.contests = { data: [] }
      }
    },
    [ContestList.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [ContestList.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      let data = action.payload
      const existingContests = JSON.parse(JSON.stringify(state.contests));
      data.data = [...existingContests.data, ...data.data]
      state.contests = data
    },
    // listAllPromos
    [listAllPromos.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      if (action?.meta?.arg?.pageNo == 1) {
        state.contests = { data: [] }
      }
    },
    [listAllPromos.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action?.payload?.message
    },
    [listAllPromos.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.offerList = action.payload
    },
  }

})

export const { setTriviaInfo, clearPromo, clearPaymentInfo, clearTrivia } = counterSlice.actions
export default counterSlice.reducer